import { C, P0, S, abs, fillAt, limb, max, sq } from '../../geometry';

export const pumpkin = {
  name: 'Pumpkin',
  colors: ['#C46A3E', '#2F9E5B'],
  draw(m, t) {
    let coil = 1.1 + 0.15 * S(t * 1.3),
      sq1 = 0.5 * S(t * 1.6),
      lf = 4 * S(t * 1.4),
      pose = P0(),
      wide = 0;
    if (m === 'happy') {
      coil = 1.1 + 0.4 * S(t * 9);
      lf = 18 * S(t * 9);
      pose.ty = -2.5 * abs(S(t * 6));
      sq1 = 1.2 * S(t * 12);
    }
    // Thinking: the vine keeps winding up into a tight curl and springing loose again.
    if (m === 'thinking') {
      coil = 1.25 + 0.85 * S(t * 2);
      lf = 10 * S(t * 2 - 1);
      sq1 = 1.2 * S(t * 2 + 1);
      pose.rot = 2 * S(t * 2);
    }
    if (m === 'talking') {
      wide = 2.5 * max(0, S(t * 10));
      coil = 1.1 + 0.2 * S(t * 10);
    }
    if (m === 'surprised') {
      coil = 0.35;
      lf = -20;
      wide = 1;
    }
    if (m === 'paused') {
      coil = 1.9;
      lf = 25;
      pose.sy = 0.93;
      pose.ty = 2;
    }
    const lobes = [
      [33, 64, 16 + sq1],
      [67, 64, 16 - sq1],
      [50, 62, 16 + wide * 0.5],
    ].map(([x, y, w], i) => ({
      c: 'a',
      pts: sq(
        x + (i === 2 ? 0 : (i ? 1 : -1) * wide),
        y,
        w + wide * 0.4,
        i === 2 ? 22 : 19,
        2.4
      ),
      n: 26,
    }));
    const vine = [[53, 41]];
    let a = -0.5;
    for (let k = 1; k < 13; k++) {
      const u = k / 12;
      a += coil * u * u * 1.5;
      const p = vine[k - 1];
      vine.push([p[0] + 3.2 * C(a), p[1] + 3.2 * S(a)]);
    }
    const leaf = [
      [49, 41],
      ...limb(49, 41, -150 + lf, 14, 5, 4).slice(1),
      ...limb(49, 41, -150 + lf, 14, -5, 4)
        .slice(1, 3)
        .reverse(),
      [49, 41],
    ];
    return {
      strokes: [
        ...lobes,
        {
          c: 'b',
          pts: [
            [50, 42],
            [51, 34],
            [55, 30],
          ],
        },
        { c: 'b', pts: vine, n: 18 },
        { c: 'b', pts: leaf, n: 12 },
      ],
      eyes: { x: 50, y: 62 },
      pose,
    };
  },
  eyesOn: 'a',
  solid: (f) => fillAt(f, 0, 1, 2),
};
